import React, {useContext} from "react"
import {injectIntl} from "react-intl";
import ValidationTabBody from "../../commonui/mheValidation/ValidationTabBody";
import {AslDeviceOverviewContext} from "./context/AslDeviceOverviewContext";
import MHEValidationContextProvider from "../../mhevalidation/context/MHEValidationContext";

const AslDeviceValidation = ({intl}) => {

    const {viewModel, dispatch} = useContext(AslDeviceOverviewContext);
    const deviceList = Object.values(viewModel.aslDeviceInformation);

    const props = {
        dispatch,
        deviceList,
        intl
    }

    return (<MHEValidationContextProvider><ValidationTabBody {...props}/></MHEValidationContextProvider> );
}

export default injectIntl(AslDeviceValidation)



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asldevice/AslDeviceValidation.js